import { declareString } from "@1js/localization";
export const SingleActionTitle = declareString("metaOS.singleActionTitle", {
  text: "Copilot prompt of the week",
  comment:
    "Text which appears as the title on the single action card with a prompt in the hero card section at the top of metaOSv2 UI.",
});
export const SingleActionDescription = declareString(
  "metaOS.singleActionDescription",
  {
    text: "Discover a new Copilot prompt each week, designed to improve efficiency in M365 apps.",
    comment:
      "Text which appears as the description on the single action card with a prompt in the hero card section at the top of metaOSv2 UI.",
  }
);
export const SingleAction2Title = declareString("metaOS.singleAction2Title", {
  text: "Browse prompts designed for your role",
  comment:
    "Text which appears as the title on the 2nd single action card with a view prompts button in the hero card section at the top of metaOSv2 UI.",
});
export const SingleAction2Description = declareString(
  "metaOS.singleAction2Description",
  {
    text: "Find prompts that fit your responsibilities, whether you're writing, analyzing data, managing projects, or streamlining tasks. Try prompts designed to support your daily work and improve efficiency.",
    comment:
      "Text which appears as the title on the 2nd single action card with a view prompts button in the hero card section at the top of metaOSv2 UI.",
  }
);
export const ViewPromptsButton = declareString("metaOS.viewPromptsButton", {
  text: "View prompts",
  comment:
    "Text which appears as the view prompts button in the hero card section at the top of metaOSv2 UI.",
});

export const SeeMoreButton = declareString("metaOS.seeMoreButton", {
  text: "See more",
  comment:
    "Text which appears as the see more button in prompt grid section when no results are found. Pressing this will show more promtps.",
});

export const SeeLessButton = declareString("metaOS.seeLessButton", {
  text: "See less",
  comment:
    "Text which appears as the see less button in prompt grid section when no results are found and see more has been pressed. Pressing this will minimize number of prompts.",
});
